import { VCol } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCol,{attrs:{"lg":"4","sm":"6","xs":"12","md":"6","cols":"12"}},[(_vm.showWidget('Transactions'))?_c('Transaction'):_vm._e(),(_vm.showWidget('Profile'))?_c('Profile'):_vm._e(),(_vm.showWidget('Custom'))?_c('Custom',{attrs:{"url":_vm.url,"url_title":_vm.url_title,"title":_vm.title,"html":_vm.html,"image_url":_vm.image_url}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }